var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition-group',{attrs:{"name":"fade","mode":"out-in","id":"slides","tag":"div"}},[_c('div',{key:_vm.image.id,staticClass:"slide-image",style:(_vm.setBackgroundImage)})])
}
var staticRenderFns = []

export { render, staticRenderFns }